import type {ReactAction} from '@netx/core/bootstrap';
import {faFilePdf} from '@fortawesome/pro-solid-svg-icons';
import {canCreatePdfFromSavedSearch} from '../enablers';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import type {SavedSearch} from '../types';
import {SEARCH_SAVED_EVENT} from './constants';
import {searchSavedActionCreatePDFDownload} from './search-saved-create-pdf-download';
import {searchSavedActionCreatePDFShareLink} from './search-saved-create-pdf-share-link';

export const searchSavedActionCreatePDFIcon = faFilePdf;

/**
 * Create pdf from saved search assets
 * @param params
 * @returns Action
 */
export const searchSavedActionCreatePDF = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-create-pdf',
	cb: () => {}, //dispatcher.trigger(SEARCH_SAVED_EVENT.CREATE_PDF, savedSearch),
	// enableTest: () => canCreatePdfFromSavedSearch(savedSearch),
	icon: searchSavedActionCreatePDFIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.CREATE_PDF;
	},
	children: [
		searchSavedActionCreatePDFDownload(savedSearch),
		searchSavedActionCreatePDFShareLink(savedSearch),
	],
	...params,
});

export default searchSavedActionCreatePDF;
